import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TaxWorkflowFilterState, TaxWorkflowFilterPayload } from "./types";

const INITIAL_STATE: TaxWorkflowFilterState = {
  filters: {
    search: "",
    order: {},
    meta: {
      page: 1,
      perPage: 10,
    },
    state: "",
    from_date: "",
    to_date: "",
    is_payed: "",
    generated_gnre: "",
    has_ncm_assigned: "",
  },
};

const taxWorkflowFilterSlice = createSlice({
  name: "taxWorkflowFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setTaxWorkflowFilter(state, action: PayloadAction<TaxWorkflowFilterPayload>) {
      const { key, value } = action.payload;
      (state.filters as Record<string, unknown>)[key] = value;
    },
    resetTaxWorkflowFilters(state) {
      state.filters = INITIAL_STATE.filters;
    },
  },
});

export const { setTaxWorkflowFilter, resetTaxWorkflowFilters } = taxWorkflowFilterSlice.actions;
export default taxWorkflowFilterSlice.reducer;
